import { isMockMode, post, simulateDelay } from "../api";

export const editOrg = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Orgs/Update`, data, {
		successMessage: "Organization successfully updated",
	});
};
